module.exports = __webpack_public_path__ + "img/balcon-2.a15c7d33.webp";